<template>
  <div>
    <h2 class="mt-4">Register</h2>

    <form class="mt-3" @submit.prevent="onSubmit">

      <div class="alert alert-danger" v-if="errors.length">
        <ul>
          <li v-for="error in errors">{{ error }}</li>
        </ul>
      </div>

      <div class="form-group" :class="{invalid: $v.email.$error}">
        <label for="email">Email</label>
        <input type="email"
              class="form-control"
              id="email"
              @blur="$v.email.$touch()"
              v-model="email">
      </div>

      <div class="form-group" :class="{invalid: $v.name.$error}">
        <label for="name">Name</label>
        <input type="text"
               class="form-control"
               id="name"
               @blur="$v.name.$touch()"
               v-model="name">
      </div>

      <div class="form-group">
        <label for="gender">Gender</label>
        <select class="form-control"
                id="gender"
                v-model="gender">
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
      </div>

      <div class="form-group" :class="{invalid: $v.country.$error}">
        <label for="country">Country</label>
        <input type="text"
               class="form-control"
               id="country"
               @blur="$v.country.$touch()"
               v-model="country">
      </div>

      <div class="form-group" :class="{invalid: $v.password.$error}">
        <label for="password">Password</label>
        <input type="password"
               class="form-control"
               id="password"
               @blur="$v.password.$touch()"
               v-model="password">
      </div>

      <p v-if="!$v.password.minLen">Password have to be at least {{ $v.password.$params.minLen.min }} characters long.</p>

      <div class="form-group" :class="{invalid: $v.confirmPassword.$error}">
        <label for="password_confirmation">Repeat password</label>
        <input type="password"
               class="form-control"
               id="password_confirmation"
               @blur="$v.confirmPassword.$touch()"
               v-model="confirmPassword">

        <p v-if="!$v.confirmPassword.sameAs">Passwords doesn't match</p>
      </div>

      <button type="submit" class="btn btn-dark" :disabled="$v.$invalid">Register</button>
    </form>

  </div>
</template>

<script>
  import { required, email, numeric, minValue, minLength, sameAs, requiredUnless } from 'vuelidate/lib/validators'

  import { mapActions } from 'vuex'

  export default {
    data() {
      return {
        email: '',
        name: '',
        gender: 'male',
        country: '',
        password: '',
        confirmPassword: '',
        errors: []
      }
    },

    methods: {
      ...mapActions('auth', ['login']),
      onSubmit() {
        const formData = {
          email: this.email,
          name: this.name,
          gender: this.gender,
          country: this.country,
          password: this.password,
          password_confirmation : this.confirmPassword
        }

        this.axios.post('/register', formData)
          .then(res => {
            this.login(res.data)
          })
          .catch(res => {
            const errors = res.response.data.errors;
            Object.keys(errors).forEach(key => {
              this.errors = this.errors.concat(errors[key])
            })
          })
      }
    },

    validations: {
      email: {
        required,
        email
      },
      name: {
        required
      },
      gender: {
        required
      },
      country: {
        required
      },
      password: {
        required,
        minLen: minLength(6)
      },
      confirmPassword: {
        sameAs: sameAs(vm => {
          return vm.password
        })
      }
    }
  }
</script>

<style scoped>

  .form-group.invalid label {
    color: red;
  }

  .form-group.invalid input{
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .form-group.invalid p {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/auth/RegisterPage.vue